import { type Constructor } from 'javascripts/shared-types';
import type Field from './Field';
import type RecordFields from './RecordFields';

type FieldDefinition = Constructor<Field>;

class FieldSet {
  fields: Field[] = [];

  constructor(public recordFields: RecordFields) {
    this.addFields(this.fieldDefinitions);
  }

  get title() {
    return 'Untitled field set';
  }

  get availableFields() {
    return this.fields.filter(field =>
      (field.constructor as typeof Field).availableForModel(
        this.modelClass,
        this.recordFields.recordLayout
      )
    );
  }

  get fieldDefinitions(): FieldDefinition[] {
    return [];
  }

  get terminologyName() {
    return this.recordFields.terminologyName;
  }

  get modelClass() {
    return this.recordFields.modelClass;
  }

  addFields(fieldDefinitions: FieldDefinition[]) {
    fieldDefinitions.forEach(field => this.addField(field));
  }

  /**
   * Adds a field to the field set. If the Field is not valid for the field set's model, it will not be added.
   */
  addField(FieldClass: Constructor<Field>) {
    const field = new FieldClass(this);

    this.fields.push(field);
  }
}

export default FieldSet;
